import { useEffect, useState } from 'react';
import vendorService from '../../../services/VendorService';

export function useFetchQboTerms() {
  const [qboTerms, setQboTerms] = useState([]);
  const [qboTermsLoading, setQboTermsLoading] = useState(true);
  const [qboTermsError, setQboTermsError] = useState('');

  useEffect(() => {
    let active = true;
    const fetchTerms = async () => {
      setQboTermsLoading(true);
      setQboTermsError('');
      try {
        const response = await vendorService.getTermsFromQBO();
        const terms = response?.data?.data?.QueryResponse?.Term || [];
        if (active) setQboTerms(terms.filter((term) => term.Active !== false && term.Id && term.Name));
      } catch (error) {
        if (active) {
          setQboTermsError(error?.response?.data?.message || error?.message || 'Could not load QBO terms');
        }
      } finally {
        if (active) setQboTermsLoading(false);
      }
    };
    fetchTerms();
    return () => {
      active = false;
    };
  }, []);

  return { qboTerms, qboTermsLoading, qboTermsError };
}
